import { APP_ROUTE, PAGES_PATH, PAGES_NAME } from "./route";
export const NOTIFICATION = {
	TYPE: {
		DEVICE: "device",
		REQUEST: "request",
		TODOLIST: "todolist",
		POST: "cminside_post",
		ALARMSG: "alarmsg"
	}
};

// in MB
export const UPLOAD_FILE_SIZE_LIMIT = 10;

export default {
	PATH: {
		REQUEST: {
			CREATE: APP_ROUTE.MAIN_APP_ROUTE_PATH + "/request/create",
			LIST: "/request"
		},
		LANDING_PAGE: {
			ROOT: "/landing",
			HOME: "/landing/login",
			REGISTER: "/register"
		},
		PROFILE: "/pages/profile",
		PROFILE_STUDENT: "/pages/profile/:studentId",
	},

	PAGES_PATH,
	PAGES_NAME,

	PERMISSION: {
		REQUEST: {
			ALL: "comay.request.request.*",
			VIEW: "comay.request.request.view",
			CREATE: "comay.request.request.create",
			UPDATE: "comay.request.request.update",
			DELETE: "comay.request.request.delete",
			VIEW_ALL: "comay.request.request.view_all",
			CAN_VIEW: "comay.request.request.can_view"
		},
		EMPLOYEE: {
			ALL: "comay.card.employee.*",
			VIEW: "comay.card.employee.view",
			CREATE: "comay.card.employee.create",
			UPDATE: "comay.card.employee.update",
			DELETE: "comay.card.employee.delete",
			VIEW_ALL: "comay.card.employee.view_all",
			CAN_VIEW: "comay.card.employee.can_view"
		},
		DEVICE: {
			ALL: "comay.cbs.device.*",
			VIEW: "comay.cbs.device.view",
			CREATE: "comay.cbs.device.create",
			UPDATE: "comay.cbs.device.update",
			DELETE: "comay.cbs.device.delete",
			VIEW_ALL: "comay.cbs.device.view_all",
			CAN_VIEW: "comay.cbs.device.can_view"
		},
		ACCESSORY: {
			ALL: "comay.cbs.accessory.*",
			VIEW: "comay.cbs.accessory.view",
			CREATE: "comay.cbs.accessory.create",
			UPDATE: "comay.cbs.accessory.update",
			DELETE: "comay.cbs.accessory.delete",
			VIEW_ALL: "comay.cbs.accessory.view_all",
			CAN_VIEW: "comay.cbs.accessory.can_view"
		},
		CATEGORY: {
			ALL: "comay.cbs.category.*",
			VIEW: "comay.cbs.category.view",
			CREATE: "comay.cbs.category.create",
			UPDATE: "comay.cbs.category.update",
			DELETE: "comay.cbs.category.delete",
			VIEW_ALL: "comay.cbs.category.view_all",
			CAN_VIEW: "comay.cbs.category.can_view"
		},
		INVENTORY: {
			ALL: "comay.rice.inventory.*",
			VIEW: "comay.rice.inventory.view",
			CREATE: "comay.rice.inventory.create",
			UPDATE: "comay.rice.inventory.update",
			DELETE: "comay.rice.inventory.delete",
			VIEW_ALL: "comay.rice.inventory.view_all",
			CAN_VIEW: "comay.rice.inventory.can_view"
		},
		TODOLIST: {
			ALL: "comay.agile.todolist.*",
			VIEW: "comay.agile.todolist.view",
			CREATE: "comay.agile.todolist.create",
			UPDATE: "comay.agile.todolist.update",
			DELETE: "comay.agile.todolist.delete",
			VIEW_ALL: "comay.agile.todolist.view_all",
			CAN_VIEW: "comay.agile.todolist.can_view"
		},
		DEPARTMENT: {
			ALL: "comay.card.department.*",
			VIEW: "comay.card.department.view",
			CREATE: "comay.card.department.create",
			UPDATE: "comay.card.department.update",
			DELETE: "comay.card.department.delete",
			VIEW_ALL: "comay.card.department.view_all",
			CAN_VIEW: "comay.card.department.can_view"
		},
		REQUEST_TYPE: {
			ALL: "comay.request.type.*",
			VIEW: "comay.request.type.view",
			CREATE: "comay.request.type.create",
			UPDATE: "comay.request.type.update",
			DELETE: "comay.request.type.delete",
			VIEW_ALL: "comay.request.type.view_all",
			CAN_VIEW: "comay.request.type.can_view"
		},
		KPI: {
			ALL: "comay.cbs.kpi.*",
			VIEW: "comay.cbs.kpi.view",
			CREATE: "comay.cbs.kpi.create",
			UPDATE: "comay.cbs.kpi.update",
			DELETE: "comay.cbs.kpi.delete",
			VIEW_ALL: "comay.cbs.kpi.view_all",
			CAN_VIEW: "comay.cbs.kpi.can_view"
		},
		TITLE: {
			ALL: "comay.card.title.*",
			VIEW: "comay.card.title.view",
			CREATE: "comay.card.title.create",
			UPDATE: "comay.card.title.update",
			DELETE: "comay.card.title.delete",
			VIEW_ALL: "comay.card.title.view_all",
			CAN_VIEW: "comay.card.title.can_view"
		},
		USER_ROLE: {
			ALL: "comay.link.userrole.*",
			VIEW: "comay.link.userrole.view",
			CREATE: "comay.link.userrole.create",
			UPDATE: "comay.link.userrole.update",
			DELETE: "comay.link.userrole.delete",
			VIEW_ALL: "comay.link.userrole.view_all",
			CAN_VIEW: "comay.link.userrole.can_view"
		},
		REPORT_FORM: {
			ALL: "comay.agile.form.*",
			VIEW: "comay.agile.form.view",
			CREATE: "comay.agile.form.create",
			UPDATE: "comay.agile.form.update",
			DELETE: "comay.agile.form.delete",
			VIEW_ALL: "comay.agile.form.view_all",
			CAN_VIEW: "comay.agile.form.can_view"
		},
		CUSTOMER: {
			ALL: "comay.cmcard.customer.*",
			VIEW: "comay.cmcard.customer.view",
			CREATE: "comay.cmcard.customer.create",
			UPDATE: "comay.cmcard.customer.update",
			DELETE: "comay.cmcard.customer.delete",
			VIEW_ALL: "comay.cmcard.customer.view_all",
			CAN_VIEW: "comay.cmcard.customer.can_view"
		},
		BACKEND_USER: {
			CREATE: "backend.user.create",
			UPDATE: "backend.user.update"
		},
		TAG: {
			VIEW: "comay.cmlink.tag.view"
		},
		// Phân loại khách hàng
		PIPELINE: {
			VIEW: "comay.cmcard.pipeline.view",
			CREATE: "comay.cmcard.pipeline.create",
			UPDATE: "comay.cmcard.pipeline.update",
			DELETE: "comay.cmcard.pipeline.delete"
		},
		PRODUCT: {
			VIEW: "comay.cmcard.product.view",
			CREATE: "comay.cmcard.product.create",
			UPDATE: "comay.cmcard.product.update",
			DELETE: "comay.cmcard.product.delete"
		},
		ALARM: {
			VIEW: "comay.cbs.alarm.view",
			CREATE: "comay.cbs.alarm.create",
			UPDATE: "comay.cbs.alarm.update",
			DELETE: "comay.cbs.alarm.delete"
		},
		CONTRACT: {
			ALL: "comay.cmhr.contract.*",
			VIEW: "comay.cmhr.contract.view",
			CREATE: "comay.cmhr.contract.create",
			UPDATE: "comay.cmhr.contract.update",
			DELETE: "comay.cmhr.contract.delete",
			VIEW_ALL: "comay.cmhr.contract.view_all",
			CAN_VIEW: "comay.cmhr.contract.can_view"
		},
		ECONOMIC_CONTRACT: {
			VIEW: "comay.cmhr.economic_contract.view",
			VIEW_ALL: "comay.cmhr.economic_contract.view_all",
			CREATE: "comay.cmhr.economic_contract.create",
			UPDATE: "comay.cmhr.economic_contract.update",
			UPDATE_ALL: "comay.cmhr.economic_contract.update_all",
			DELETE: "comay.cmhr.economic_contract.delete",
			DELETE_ALL: "comay.cmhr.economic_contract.delete_all",
			CAN_VIEW: "comay.cmhr.economic_contract.can_view"
		},
		STOCK_CARD: {
			CREATE: "comay.cmcard.product.input_product_quantity"
		},
		PRODUCT_STOCK: {
			CREATE: "comay.cmcard.product.create_product_stock"
		}
	},
	request: {
		type: {
			single: 0,
			multiple: 1
		},
		control: {
			text: 1,
			textarea: 2,
			dropdown: 3,
			radio: 4,
			checkbox: 5,
			number: 6,
			calculator: 7,
			relation: 8,
			attach: 9,
			datetime: 10,
			repeater: 11,
			label: 12,
			autofill: 13
		}
	},

	REQUEST_TYPE_GENERAL: 0,
	REQUEST_TYPE_DEVICE: 1,
	DYNAMIC_FORM_FIELD_CONTROLS: [
		{ id: 1, name: "Text", attributes: '{"validation": null}' },
		{ id: 2, name: "Textarea", attributes: '{"type":"raw"}' },
		{ id: 3, name: "Dropdown", attributes: '{"options": []}' },
		{ id: 4, name: "Radio", attributes: '{"options": []}' },
		{ id: 5, name: "Checkbox", attributes: '{"options": []}' },
		{ id: 6, name: "Number", attributes: '{"unit":"", "format": "number"}' },
		{ id: 7, name: "Calculator", attributes: '{"cal_exp": "", "show_as_text": false}' },
		{ id: 8, name: "Relation", attributes: '{"is_multiple": false, "related_model": null, "is_notification": null}' },
		{ id: 9, name: "Attachment", attributes: "{}" },
		{ id: 10, name: "Datetime", attributes: '{"type": "datetime", "validation": { "min": null, "max": null, "from_now": { "unit": "hour", "value": null }, "mode": "absolute" }}' },
		{ id: 11, name: "Repeater", attributes: "{}" },
		{ id: 12, name: "Label", attributes: '{"value": ""}' },
		{ id: 13, name: "Autofill", attributes: '{"form_id": "", "column": "", "form_value": 0}' }
	],
	DYNAMIC_FORM_FIELD_CONTROL_TYPES: {
		NUMBER: {
			TYPE_NONE: "none",
			TYPE_MONEY: "money",
			TYPE_NUMERIC: "number"
		},
		DATETIME: {
			TYPE_DATE: "date",
			TYPE_TIME: "time",
			TYPE_DATETIME: "datetime"
		},
		TEXTAREA: {
			TYPE_RAW: "raw",
			TYPE_RICHTEXT: "richtext"
		},
		DATETIME_VALIDATION: {
			TYPE_DATE_RANGE: "absolute",
			TYPE_AFTER_CURRENT_TIME: "relative"
		}
	},

	LIMIT_BY_PAGE: 10,
	COMAY_LINK_URL: "http://comaylink.com/",

	CATEGORY_ICONS: [
		{
			iconName: "nucleo-shape-rectangle-2",
			iconContent: "nucleo-shape-rectangle-2"
		},
		{
			iconName: "nucleo-shape-oval-4",
			iconContent: "nucleo-shape-oval-4"
		},
		{
			iconName: "nucleo-shape-triangle-2-2",
			iconContent: "nucleo-shape-triangle-2-2"
		},
		{
			iconName: "nucleo-shape-polygon-2-2",
			iconContent: "nucleo-shape-polygon-2-2"
		},
		{
			iconName: "nucleo-octagon-2",
			iconContent: "nucleo-octagon-2"
		},
		{
			iconName: "nucleo-shape-star-2",
			iconContent: "nucleo-shape-star-2"
		},
		{
			iconName: "nucleo-laptop-2",
			iconContent: "nucleo-laptop-2"
		},
		{
			iconName: "nucleo-delivery-2",
			iconContent: "nucleo-delivery-2"
		},
		{
			iconName: "nucleo-plane-2",
			iconContent: "nucleo-plane-2"
		},
		{
			iconName: "nucleo-name-card-2",
			iconContent: "nucleo-name-card-2"
		},
		{
			iconName: "nucleo-printer",
			iconContent: "nucleo-printer"
		},
		{
			iconName: "nucleo-settings-3",
			iconContent: "nucleo-settings-3"
		},
		{
			iconName: "nucleo-car-front-3",
			iconContent: "nucleo-car-front-3"
		},
		{
			iconName: "nucleo-ruler-pencil",
			iconContent: "nucleo-ruler-pencil"
		},
		{
			iconName: "nucleo-open-folder",
			iconContent: "nucleo-open-folder"
		},
		{
			iconName: "nucleo-tablet-mobile",
			iconContent: "nucleo-tablet-mobile"
		},
		{
			iconName: "nucleo-desk",
			iconContent: "nucleo-desk"
		}
	],
	ROLES_VALUE: {
		TRUE: "1",
		FALSE: "0"
	},
	PICKER_COLORS: [
		{ id: 1, value: "#BDBDBD" },
		{ id: 2, value: "#EB5757" },
		{ id: 3, value: "#219653" },
		{ id: 4, value: "#F2994A" },
		{ id: 5, value: "#FFC736" },
		{ id: 6, value: "#1261FB" }
	],
	PICKER_MARK_COLORS: [
		{ id: 1, value: "#BDBDBD" },
		{ id: 2, value: "#F19292" },
		{ id: 3, value: "#82C4C3" },
		{ id: 4, value: "#F5B971" },
		{ id: 5, value: "#F6D186" },
		{ id: 6, value: "#6886C5" }
	],
	SOCKET_EVENT: {
		NEW_MISSION_DAY: "todo_created",
		DELETED_MISSION_DAY: "todo_deleted",
		DONE_MISSION_DAY: "todo_done",
		UPDATED_MISSION_DAY: "todo_updated"
	},
	TODO_TYPE: {
		NORMAL: 0,
		SCHEDULE: 1
	},
	TODO_CATEGORY: {
		NORMAL: 0,
		DEVICE: 1
	},
	HUMAN_ROLES_FOR: {
		PEOPLE: "people",
		TASK: "task",
		REQUEST: " request"
	},
	TEMPLATE_VARIABLES: {
		TODO_WATCHER_CONTENT: "todolist_watcher_content",
		REQUEST_NOTIFICATION_CONTENT: "request_notify_content"
	},
	NOTIFICATION,
	RELATION_MODELS: {
		POST: "Post",
		TITLE: "Title",
		TODO: "Todolist",
		EMPLOYEE: "Employee",
		REQUEST: "RequestV2",
		DEPARTMENT: "Department",
		DEVICE: "Device",
		REPORT_FORM: "Form",
		ACCESSORY: "Accessory",
		PRODUCT: "Product"
	},
	DYNAMIC_FORM_FIELD_INFO_POSITION: {
		BOTTOM: 1,
		TOP: 2,
		ICON: 3
	},
	TODO_FILTER_FLAG: {
		"created-by-me": 1,
		"assigned-to-me": 2,
		"following-by-me": 3,
		"schedule-by-me": -1
	},
	REQUEST_FILTER_TYPE: {
		"created-by-me": true,
		"relating-to-me": false,
		"approve-by-me": true
	},
	DYNAMIC_FORM_FIELD_MODELS: {
		REPORT_FIELD: "Form",
		TODOLIST_REPORT_FORM: "Todolist",
		REQUEST_TYPE_STEP_FIELD: "ReqStatus",
		REQUEST_TYPE_PARENT_FIELD: "ReqType"
	},
	REQUEST_STATUSES: {
		WAITING: 0,
		APPROVED: 1,
		REJECTED: 2,
		CANCELED: -1,
		PENDING_INPUT: 3
	},
	USER_OPTION_TYPE: {
		REQUEST: "RequestV2",
		TODO: "Todolist"
	},
	REMINDER: {
		PERIOD_TYPE: {
			BEFORE: 1,
			AFTER: 2
		},
		MILESTONE_TYPE: {
			START_DATE: 1,
			DEADLINE_DATE: 2
		},
		REMINDERABLE_TYPE: {
			TODO_LIST: "Todolist"
		}
	},
	TODO_ITEM_STATUSES: {
		STATUS_NEW: 0,
		STATUS_DONE: 1,
		STATUS_CANCELED: 2,
		STATUS_OUT_OF_DATE: 3,
		STATUS_DOING: 4,
		STATUS_CLOSED: 5,
		STATUS_PRECREATED: 6,
		STATUS_REJECTED: 7
	},
	TODO_ITEM_PRIORITY: {
		LOW: 0,
		MEDIUM: 1,
		HIGH: 2,
		CRITICAL: 3
	},
	TEXT_STATUS_COLOR: { over: "text-over-time", 0: "text-new", 1: "text-done", 2: "text-cancel", 4: "text-doing", 5: "text-complete", 7: "text-reject" },
	BG_STATUS_COLOR: { over: "bg-over", 0: "bg-new", 1: "bg-done", 2: "bg-cancel", 4: "bg-doing", 5: "bg-complete", 7: "bg-reject" },
	ACCESSORY_TYPE: {
		ACCESSORY: 0,
		MATERIAL: 1
	},
	KPIV2: {
		KPIABLE_TYPE: {
			DEVICE: "Device",
			CATEGORY: "Category"
		}
	},
	LOGS_DEVICE_TODO_TYPE: {
		CURRENT: "CURRENT",
		DONE: "DONE"
	},
	ALARM_NOTI_TYPE: {
		MAIL: 1,
		APP: 2
	},
	CONTRACT_STATUS: {
		ACTIVE: 1,
		PENDING: 0,
		DELETED: -1
	},
	DOWNLOAD_EMPLOYEE: {
		BIRTH_DAY: "BIRTH_DAY",
		KPI: "KPI",
	},
	INIT_STUDENT_DATA: {
		personal_info: {
			full_name: "", // Họ và tên
			gender: "", // Giới tính
			date_of_birth: "", // Ngày sinh
			place_of_birth: "", // Nơi sinh
			ethnicity: "", // Dân tộc
			religion: "", // Tôn giáo
			personal_phone: "", // SĐT cá nhân
			personal_email: "", // Email cá nhân
			hometown: "", // Quê quán
			permanent_address: {
				state: "",
				district: "",
				ward: "",
				detail: "" // Chi tiết địa chỉ thường trú
			}, // Địa chỉ thường trú
			id_card: {
				number: "", // Số CMND/CCCD
				issue_date: "", // Ngày cấp CMND/CCCD
				issue_place: "" // Nơi cấp CMND/CCCD
			}, // Thông tin CMND/CCCD
			relatives: [
				{
					relationship: "", // Mối quan hệ
					name: "", // Họ và tên
					year_of_birth: "", // Năm sinh
					phone: "", // Số điện thoại
					occupation: "", // Nghề nghiệp
					income: "" // Thu nhập
				}
			] // Người thân
		},
		student_info: {
			student_id: "", // Mã số sinh viên
			room: "", // Phòng
			course: "", // Khóa
			school: "", // Trường
			faculty: "", // Khoa
			major: "", // Ngành học
			specialty: "", // Chuyên ngành
			university_id: "", // Mã số sinh viên
			class: "", // Lớp
			student_email: "", // Email sinh viên
			bank_account: {
				account_number: "", // Số tài khoản
				bank_name: "Sacombank", // Tên ngân hàng
				branch: "PGD NGUYEN CONG TRU", // Chi nhánh
				account_holder: "" // Người thụ hưởng
			} // Tài khoản ngân hàng
		}
	}
};
